import script from "./deliOnceImg10.vue?vue&type=script&setup=true&lang=js"
export * from "./deliOnceImg10.vue?vue&type=script&setup=true&lang=js"

import "./deliOnceImg10.vue?vue&type=style&index=0&id=74776ebe&lang=less"

const __exports__ = script;

export default __exports__